import React from "react";
import { Row, Col, Container, Alert, Button, Badge } from "reactstrap";
import { Link } from "react-router-dom";
import MainPage from "../Components/Shared/MainPage";
import LoadingSpinner from "../Components/Common/LoadingSpinner";
import OrderSummary from "../Components/Common/OrderSummary";
import OrderSubmissionModal from "../Components/Common/OrderSubmissionModal";
import queryString from "query-string";
import {
  PayPalExpressTokenApi,
  CheckoutPayPalExpressApi,
  ImageUrls,
} from "../Code/Data";
import { scrollToElement } from "../Code/Utilities";

export default class PayPalCheckout extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      errMsg: null,
      loading: true,
      showSubmitButton: true,
    };

    this.submitOrder = this.submitOrder.bind(this);
  }

  async componentWillMount() {
    const { token, PayerID } = queryString.parse(this.props.location.search);
    let response = await PayPalExpressTokenApi(token, PayerID);
    if (response.Succeeded) {
      this.setState({ loading: false });
    } else {
      this.setState({ loading: false, errMsg: response.ErrorMessage });
      setTimeout(
        () =>
          response.ErrorMessage && scrollToElement(".alert-danger", true, 0),
        500
      );
    }
  }

  async submitOrder() {
    this.setState({ showSubmitButton: false });
    let { shoppingCart } = this.props;
    console.log("PAYPAL CHECKOUT REQUEST");
    let response = await CheckoutPayPalExpressApi();
    console.log("PAYPAL CHECKOUT RESPONSE", response);
    if (response.Succeeded) {
      let hasRedemptions = shoppingCart.Items.reduce(
        (acc, item) => acc || item.Type === "Redemption Codes",
        false
      );
      window.location.href = `https://${window.location.host}/Purchase/OrderComplete?purchaseId=${response.PurchaseId}&hasRedemptions=${hasRedemptions}`;
    } else {
      this.setState({ errMsg: response.ErrorMessage, showSubmitButton: true });
      setTimeout(
        () =>
          response.ErrorMessage && scrollToElement(".alert-danger", true, 0),
        500
      );
    }
  }

  render() {
    const { shoppingCart } = this.props;
    const { loading, errMsg, showSubmitButton } = this.state;

    if (loading) {
      return <LoadingSpinner />;
    } else if (!!errMsg && !shoppingCart) {
      return <MainPage title={errMsg} />;
    }

    return (
      <Container className="cart-page">
        <Row>
          <Col md={8} className="left-pane">
            <Container>
              <Row>
                <h2>PayPal Checkout</h2>
              </Row>
              {errMsg ? (
                <Row>
                  <Alert color="danger">{errMsg}</Alert>
                </Row>
              ) : (
                <Row>
                  <Alert color="success">
                    Your PayPal details have been verified, click "Submit Order"
                    to complete your purchase.
                  </Alert>
                </Row>
              )}
              <Row>
                {shoppingCart && (
                  <div>
                    <Container className="cart-items">
                      {shoppingCart.Items.map(item => (
                        <Row key={item.PaidItemId}>
                          <Col md={2}>
                            {item.CardImageUrl ||
                            ImageUrls[item.ShoppingCartItemTypeId] ? (
                              <img
                                className="img-fluid"
                                src={
                                  item.CardImageUrl ||
                                  ImageUrls[item.ShoppingCartItemTypeId]
                                }
                                alt={item.Type}
                              />
                            ) : (
                              <div className="cart-image-spacer"></div>
                            )}
                          </Col>
                          <Col md={6}>
                            <h3>{item.Type}</h3>
                            <p>{item.ShortDescription}</p>
                            <p>{item.Description}</p>
                            <p>{item.IsBulkHiddenAmount ? 'Cost per code' :'Denomination'}: ${item.Denomination.toFixed(2)}</p>
                            {item.canEdit && (
                              <p>
                                <a href={item.editUrl}>Edit Order</a>
                              </p>
                            )}
                          </Col>
                          <Col md={2}>
                            <p>${item.TotalForCards.toFixed(2)}</p>
                          </Col>
                          <Col md={2}>
                            <Badge className="quantity-badge">
                              {item.Quantity}
                            </Badge>
                          </Col>
                        </Row>
                      ))}
                    </Container>
                  </div>
                )}
              </Row>
              <Row>
                {showSubmitButton && (
                  <Button color="primary" onClick={this.submitOrder}>
                    Submit Order
                  </Button>
                )}
              </Row>
            </Container>
          </Col>
          <Col md={4} className="right-pane">
            <OrderSummary shoppingCart={shoppingCart} />
            <div className="submit-area">
              {showSubmitButton && (
                <Button color="primary" onClick={this.submitOrder}>
                  Submit Order
                </Button>
              )}
              <div>
                <Link to="/Purchase/ShoppingCart">Edit Order</Link>
              </div>
            </div>
          </Col>
        </Row>
        <OrderSubmissionModal isOpen={!showSubmitButton} />
      </Container>
    );
  }
}
